<template>
  <div class="wrapper" :class="{'ended-call': videoCallEnded}">
    <div class="d-flex align-self-stretch top-items" v-if="!videoCallEnded">
      <div class="d-flex flex-column mr-auto">
        <div class="body-1 white--text font-weight-bold">
          <div class="d-block">
            <span v-if="params.from != 'doctor'">Dr.</span>
            {{params.from == 'doctor' ? params.travellerFirstName : params.doctorFirstName}}
            {{params.from == 'doctor' ? params.travellerLastName : params.doctorLastName}}
          </div>
          <div class="d-block body-2">{{timer | minuteSeconds}}</div>
        </div>
      </div>
      <div id="local"></div>
    </div>

    <div v-if="!participantConnected && params.from == 'doctor'">
      <v-progress-circular indeterminate color="white" size="40" width="3" class="mt-12"></v-progress-circular>
    </div>

    <div
      class="my-auto d-flex flex-column align-center"
      v-if="!participantConnected && params.from != 'doctor' && !videoCallEnded"
    >
      <div class="doctor-avatar-wrapper mb-2">
        <img src="@/assets/doctor-avatar.svg" />
      </div>
      <div
        class="body-2 white--text text-center"
      >{{params.lang == 'el' ? 'Αναμονή απάντησης του γιατρού...' : 'Waiting for the doctor to respond...'}}</div>
    </div>

    <div id="remote" v-show="participantConnected && !videoCallEnded"></div>

    <div v-if="videoCallEnded" class="d-flex flex-column align-center">
      <div class="video-call-ended mb-4">
        <img src="@/assets/logo.svg" />
      </div>

      <div
        class="body-1 primary--text"
      >{{this.params.lang == 'el' ? 'Η βίντεο κλήση έχει τερματιστεί' : 'Video call has ended'}}</div>
    </div>

    <div
      class="d-flex align-center justify-center align-self-stretch mt-auto buttons"
      v-if="!videoCallEnded"
    >
      <v-btn class="mr-4" fab small outlined color="white" @click="changeMicState">
        <v-icon small>{{mic ? 'mic_off' : 'mic'}}</v-icon>
      </v-btn>

      <v-btn
        class="mr-4"
        fab
        small
        depressed
        color="error"
        @click="endVideoCall"
        :loading="endCallLoader"
      >
        <v-icon small>call_end</v-icon>
      </v-btn>

      <v-btn fab small outlined color="white" @click="changeCameraState">
        <v-icon small>{{cam ? 'videocam_off' : 'videocam'}}</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import * as Video from "twilio-video";
import axios from "axios";

export default {
  filters: {
    minuteSeconds: function(value) {
      const minutes = Math.floor(value / 60);
      return (
        minutes.toString().padStart(2, "0") +
        ":" +
        (value - minutes * 60).toString().padStart(2, "0")
      );
    }
  },
  data() {
    return {
      params: null,
      room: null,
      localTrack: null,
      participantConnected: false,
      mic: true,
      cam: true,
      timer: 0,
      interval: null,
      videoCallEnded: false,
      loader: false,
      endCallLoader: false,
      tracksCleared: false
    };
  },
  created() {
    this.params = this.$route.query;

    const twilioToken =
      this.params.from == "doctor"
        ? this.params.doctorTwilioToken
        : this.params.travellerTwilioToken;

    Video.connect(twilioToken, {
      name: this.params.videoCallRoom
    })
      .then(room => {
        this.room = room;

        room.localParticipant.videoTracks.forEach(track => {
          document.getElementById("local").appendChild(track.track.attach());
          this.localTrack = track.track;
        });

        //show participants already in the room
        room.participants.forEach(participant => {
          participant.tracks.forEach(publication => {
            if (publication.track) {
              document
                .getElementById("remote")
                .appendChild(publication.track.attach());
              this.participantConnected = true;
            }
          });

          participant.on("trackSubscribed", track => {
            document.getElementById("remote").appendChild(track.attach());
            this.participantConnected = true;
          });
        });

        //when participants connect
        room.on("participantConnected", participant => {
          participant.tracks.forEach(publication => {
            if (publication.isSubscribed) {
              document
                .getElementById("remote")
                .appendChild(publication.track.attach());
              this.participantConnected = true;
            }
          });

          participant.on("trackSubscribed", track => {
            document.getElementById("remote").appendChild(track.attach());
            this.participantConnected = true;
          });
        });

        room.once("participantDisconnected", participant => {
          this.videoCallEnded = true;
          this.clearTracks();
        });

        room.on("disconnected", (room, error) => {
          this.videoCallEnded = true;
          this.clearTracks();
        });
      })
      .catch(() => {
        this.clearTracks();
        this.videoCallEnded = true;
      });
  },
  methods: {
    endVideoCall() {
      this.endCallLoader = true;

      axios
        .post(
          `${process.env.VUE_APP_BASEURL}/${
            this.params.from == "doctor" ? "doctor" : "traveller"
          }/videocall/end`,
          {
            doctorId: this.params.doctorId,
            videoCallRoom: this.params.videoCallRoom
          },
          {
            headers: {
              Authorization: `Bearer ${this.params.jwt}`
            }
          }
        )
        .then(res => {
          this.clearTracks();
          this.videoCallEnded = true;
          this.endCallLoader = false;
        })
        .catch(er => {
          this.clearTracks();
          this.videoCallEnded = true;
          this.endCallLoader = false;
        });
    },
    changeCameraState() {
      if (this.cam) {
        this.room.localParticipant.videoTracks.forEach(track => {
          track.track.disable();
        });
        this.localTrack.disable();
      } else {
        this.room.localParticipant.videoTracks.forEach(track => {
          track.track.enable();
        });
        this.localTrack.enable();
      }

      this.cam = !this.cam;
    },
    changeMicState() {
      if (this.mic) {
        this.room.localParticipant.audioTracks.forEach(track => {
          track.track.disable();
        });
      } else {
        this.room.localParticipant.audioTracks.forEach(track => {
          track.track.enable();
        });
      }

      this.mic = !this.mic;
    },
    clearTracks() {
      if (this.tracksCleared) return;
      this.tracksCleared = true;

      let remote = document.getElementById("remote");
      while (remote.firstChild) {
        remote.removeChild(remote.firstChild);
      }

      let local = document.getElementById("local");
      while (local.firstChild) {
        local.removeChild(local.firstChild);
      }
    }
  },
  watch: {
    participantConnected(newValue, oldValue) {
      if (newValue && !oldValue && !this.interval) {
        this.interval = setInterval(() => {
          this.timer++;
        }, 1000);
      }
    }
  },
  destroyed() {
    if (this.room) this.room.disconnect();
    if (this.localTrack) this.localTrack.stop();
    clearInterval(this.interval);
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  background-color: var(--v-primary-base);

  padding: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  &.ended-call {
    background-color: #fff;
  }
}

.top-items,
.buttons {
  z-index: 10;
}

.doctor-avatar-wrapper {
  height: 120px;
  width: 120px;
  border-radius: 50%;
  overflow: hidden;
  background-color: lighten(#00a9dc, 8%);
  display: flex;
  align-items: flex-end;
  justify-content: center;

  img {
    height: 80%;
    width: 80%;
    filter: invert(100%) sepia(3%) saturate(12%) hue-rotate(103deg)
      brightness(105%) contrast(105%);
  }
}
</style>